/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Google Natural Language API text span object (https://cloud.google.com/natural-language/docs/reference/rest/v1/TextSpan?hl=ja)
 * @export
 * @interface NaturalLanguageTextSpan
 */
export interface NaturalLanguageTextSpan {
    /**
     * The content of the output text.
     * @type {string}
     * @memberof NaturalLanguageTextSpan
     */
    content: string;
    /**
     * The API calculates the beginning offset of the content in the original document according to the EncodingType specified in the API request.
     * @type {number}
     * @memberof NaturalLanguageTextSpan
     */
    beginOffset: number;
}

export function NaturalLanguageTextSpanFromJSON(json: any): NaturalLanguageTextSpan {
    return NaturalLanguageTextSpanFromJSONTyped(json, false);
}

export function NaturalLanguageTextSpanFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaturalLanguageTextSpan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': json['content'],
        'beginOffset': json['beginOffset'],
    };
}

export function NaturalLanguageTextSpanToJSON(value?: NaturalLanguageTextSpan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
        'beginOffset': value.beginOffset,
    };
}

